import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { CheckCircle } from 'lucide-react';

export const TeamAssignDialog = ({
  open,
  onOpenChange,
  teamMembers,
  assignedSelection,
  toggleUserAssignment,
  onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md border border-zinc-200  rounded-none p-0 max-h-[90vh] overflow-hidden flex flex-col">
      <DialogHeader className="p-6 pb-0 flex-shrink-0">
        <DialogTitle className="text-2xl font-heading font-bold uppercase tracking-wide">Assign Team Members</DialogTitle>
      </DialogHeader>

      <div className="p-6 pt-4 overflow-y-auto flex-1">
        <p className="text-sm text-zinc-500 mb-4">
          Select team members to assign to this project. Foremen will only see projects they are assigned to.
        </p>

        {teamMembers.length === 0 ? (
          <p className="text-zinc-500 text-center py-4">No team members found. Invite members from Settings.</p>
        ) : (
          <div className="space-y-2">
            {teamMembers.map((member) => (
              <button
                key={member.user_id}
                type="button"
                onClick={() => toggleUserAssignment(member.user_id)}
                data-testid={`assign-member-${member.user_id}`}
                className={`w-full flex items-center gap-3 p-3 border border-zinc-200 text-left transition-colors ${
                  assignedSelection.includes(member.user_id)
                    ? 'bg-primary/20 border-primary'
                    : 'bg-white hover:bg-zinc-50'
                }`}
              >
                <div className={`w-6 h-6 border border-zinc-200 flex items-center justify-center flex-shrink-0 ${
                  assignedSelection.includes(member.user_id) ? 'bg-primary' : 'bg-white'
                }`}>
                  {assignedSelection.includes(member.user_id) && (
                    <CheckCircle className="w-4 h-4 text-zinc-900" />
                  )}
                </div>
                {member.picture ? (
                  <img src={member.picture} alt={member.name} className="w-10 h-10 rounded-full border border-zinc-200 object-cover" />
                ) : (
                  <div className="w-10 h-10 rounded-full border border-zinc-200 bg-zinc-700 flex items-center justify-center">
                    <span className="text-white text-sm font-bold">{member.name?.charAt(0)?.toUpperCase()}</span>
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-sm truncate">{member.name}</p>
                  <p className="text-xs text-zinc-500 truncate">{member.email}</p>
                </div>
                <span className={`px-2 py-0.5 text-xs font-bold uppercase border border-black flex-shrink-0 ${
                  member.role === 'Owner' ? 'bg-primary text-zinc-900' :
                  member.role === 'Project Manager' ? 'bg-blue-500 text-white' : 'bg-zinc-500 text-white'
                }`}>
                  {member.role === 'Project Manager' ? 'PM' : member.role}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="p-6 pt-0 border-t-2 border-black bg-white flex-shrink-0">
        <p className="text-xs text-zinc-500 mb-3">
          {assignedSelection.length} member{assignedSelection.length !== 1 ? 's' : ''} selected
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="flex-1 h-10 bg-white text-zinc-900 font-bold uppercase border border-zinc-200 hover:bg-zinc-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            data-testid="save-assignments-btn"
            className="flex-1 h-10 bg-primary text-zinc-900 font-bold uppercase border border-zinc-200  hover:bg-primary-hover active:translate-y-1"
          >
            Save
          </button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
